import { Radio } from '@kula-ai/components';
import { Flex } from '@chakra-ui/react';

export const YesNo = () => {
  return (
    <Flex gap="12px" pointerEvents="none">
      <Radio
        value="yes"
        label="Yes"
        checked={true}
        onChange={() => {}}
        cursor="not-allowed"
      />
      <Radio
        value="no"
        label="No"
        checked={false}
        onChange={() => {}}
        cursor="not-allowed"
      />
    </Flex>
  );
};
